import React from 'react';
import { Home, Building2, Battery, Wrench } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { mockServices } from '../mock';

const iconMap = {
  Home: Home,
  Building2: Building2,
  Battery: Battery,
  Wrench: Wrench
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our{' '}
            <span style={{background: 'linear-gradient(90deg, #2CC84B, #00BCD4)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>Solar</span>{' '}
            Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Complete end-to-end solar EPC services for residential, commercial, and industrial clients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-t-4 hover:shadow-[0_0_20px_rgba(44,200,75,0.15)]"
                style={{borderTopColor: '#2CC84B'}}
              >
                <CardHeader>
                  <div className="w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" style={{background: 'linear-gradient(135deg, rgba(44,200,75,0.15), rgba(0,188,212,0.15))'}}>
                    <IconComponent className="w-7 h-7" style={{color: '#2CC84B'}} />
                  </div>
                  <CardTitle className="text-xl">{service.title}</CardTitle>
                  <CardDescription className="text-gray-600 mt-2">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2 text-sm text-gray-600">
                        <span className="mt-1" style={{color: '#2CC84B'}}>✓</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
